import { render, staticRenderFns } from "./PowerAdd.vue?vue&type=template&id=d951df74&"
import script from "./PowerAdd.vue?vue&type=script&lang=js&"
export * from "./PowerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d951df74')) {
      api.createRecord('d951df74', component.options)
    } else {
      api.reload('d951df74', component.options)
    }
    module.hot.accept("./PowerAdd.vue?vue&type=template&id=d951df74&", function () {
      api.rerender('d951df74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/Power/PowerAdd.vue"
export default component.exports